import { ApiClient } from '../api-client';

const StudentApi = ApiClient.service.student;

/**
 *  useStudentApi is a hook that returns a reusable axios instance with auth
 * @returns {AxiosInstance}
 */
const useStudentApi = () => {
  return StudentApi;
};

export { StudentApi, useStudentApi };
